module.exports = __webpack_public_path__ + "img/1_2.908a8c07.png";